import React from 'react';
import Image from 'next/image';
import classNames from 'classnames';

import VideoPlayer from '../../VideoPlayer';

import { objToCamelCase } from '../../../utils/helper';
import usePlayerEventCapture from '../../../hooks/usePlayerEventCapture';

import styles from './DemoVideos.module.scss';

function DemoVideos({ videos, courseId, defaultLanguage, onLanguageChange = null }) {
  const [language, setLanguage] = React.useState(() => defaultLanguage ?? null);
  const [currentVideo, setCurrentVideo] = React.useState(null);

  const { playerRef } = usePlayerEventCapture(courseId, language, currentVideo, {
    syncProgress: false,
    autoPlay: false,
    onPlay: () => null,
  });

  React.useEffect(() => {
    if (videos[0]?.language_id) {
      setLanguage(videos[0]?.language_id);
    }
  }, [videos]);

  React.useEffect(() => {
    // eslint-disable-next-line no-unused-expressions
    typeof onLanguageChange === 'function' && onLanguageChange(language);
  }, [language, onLanguageChange]);

  const demoVideos = React.useMemo(() => {
    if (language) {
      return videos.find((video) => video?.languageId === language)?.demoVideos ?? [];
    }

    return [];
  }, [language, videos]);

  React.useEffect(() => {
    if (currentVideo === null && demoVideos.length) {
      setCurrentVideo(objToCamelCase(demoVideos[0]));
    }
  }, [currentVideo, demoVideos]);

  const handlePlaylistItemClick = (video) => () => {
    setCurrentVideo(objToCamelCase(video));
  };

  if (demoVideos.length === 0) return null;

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h3 className={styles.title}>Demo Videos</h3>
      </header>

      <div className={styles.contentContainer}>
        <div className={styles.playerContainer}>
          {currentVideo && (
            <VideoPlayer
              ref={playerRef}
              video={{
                drmProvider: 'keyos',
                isDrmEnabled: false,
                videoUrl: currentVideo.s3Enabled ? currentVideo.s3Url : currentVideo.videoUrl,
                player: 'SHAKA',
              }}
            />
          )}
        </div>
        <div className={styles.playlistContainer}>
          <ul className={styles.playlist}>
            {demoVideos.map((video) => (
              <li key={video?.videoUrl}>
                <div className={styles.playlistItem} onClick={handlePlaylistItemClick(video)}>
                  <div className={classNames(styles.thumbnailWrapper, { [styles.noThumbnail]: !video?.thumbnail })}>
                    {video?.thumbnail && <Image src={video?.thumbnail} height={150} width={280} alt="Demo Video" />}
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default DemoVideos;
